import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-dashboard",
  "use": "icon-menu-dashboard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-dashboard\">\n<path d=\"M4.66667 0.963867V15.9639H2.16667C1.28803 15.9639 0.568196 15.284 0.504571 14.4216L0.5 14.2972V2.63053C0.5 1.7519 1.1799 1.03206 2.04228 0.968439L2.16667 0.963867H4.66667ZM13.8333 0.963867C14.712 0.963867 15.4318 1.64376 15.4954 2.50615L15.5 2.63053V14.2972C15.5 15.1759 14.8201 15.8957 13.9577 15.9593L13.8333 15.9639H6.33333V0.963867H13.8333Z\" fill=\"#314455\" />\n<path d=\"M4.66667 0.963867V15.9639H2.16667C1.28803 15.9639 0.568196 15.284 0.504571 14.4216L0.5 14.2972V2.63053C0.5 1.7519 1.1799 1.03206 2.04228 0.968439L2.16667 0.963867H4.66667ZM13.8333 0.963867C14.712 0.963867 15.4318 1.64376 15.4954 2.50615L15.5 2.63053V14.2972C15.5 15.1759 14.8201 15.8957 13.9577 15.9593L13.8333 15.9639H6.33333V0.963867H13.8333Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-dashboard.svg
// module id = wCCi
// module chunks = 258